if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadData(url) {
          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('items-grid');
            const newProducts = productGrid.getElementsByClassName('grid-item');
            let productsOnPage = document.getElementById("items-grid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }
            for (let i = 0; i < newProducts.length; i++) {
              setTimeout(() => {
                productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
                if (i === newProducts.length - 1) {
                  this._renderButton(html);
                  this._syncUrl(url);
                }
              }, i*300);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          })
        },
        // Yüklenen sayfa numarasını adres çubuğuna yazar (ClickUp 86eybt9mt).
        // Böylece kullanıcı sayfayı yenilediğinde/paylaştığında aynı sayfada kalır ve
        // taranan adresle görünen içerik tutarlı olur. pushState yerine replaceState:
        // geri tuşu davranışını bozmaz (her yükleme ayrı geçmiş adımı olmaz).
        _syncUrl(loadedUrl) {
          try {
            const target = new URL(loadedUrl, window.location.origin);
            const page = target.searchParams.get('page');
            if (!page) return;
            const current = new URL(window.location.href);
            if (current.searchParams.get('page') === page) return;
            current.searchParams.set('page', page);
            window.history.replaceState({}, '', current.pathname + current.search + current.hash);
          } catch (e) { /* adres güncellenemezse sayfalama yine de çalışır */ }
        },
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}